import { readState } from "@/__main__/app-state.mjs";
import { CHAMP_PREVIEW_BLACKLIST } from "@/game-tft/constants.mjs";

/**
 * Get an array of units by trait and type
 * @param {string} trait eg. syndicate, bodyguard
 * @param {'all'|'origins'|'classes'} type all, origins, classes
 * @param {string} set eg. set6_5, set6
 * @returns {*[]}
 */
export function getChampionsByTrait(trait, type, set) {
  const hash = {};
  if ([trait, set].some((i) => typeof i === "undefined")) return [];
  const champions = readState.tft[set]?.champions;
  for (const key in champions) {
    if (typeof hash[key] !== "undefined") continue;
    const champion = champions[key];
    const championBySet = champion;
    if (
      !championBySet ||
      CHAMP_PREVIEW_BLACKLIST[set]?.includes(champion.apiKey)
    )
      continue;
    if (
      ["classes", "all"].includes(type) &&
      championBySet.class?.includes(trait)
    ) {
      hash[key] = {
        ...championBySet,
        key: champion.apiKey,
        name: champion.name,
      };
    }
    if (typeof hash[key] !== "undefined") continue;
    if (
      ["origins", "all"].includes(type) &&
      championBySet.origin?.includes(trait)
    ) {
      hash[key] = {
        ...championBySet,
        key: champion.apiKey,
        name: champion.name,
      };
    }
  }
  return Object.values(hash).sort((a, b) => a.cost - b.cost);
}
